import type { ReactNode } from 'react';

/** Aviso de erro do formulário inteiro, anunciado por leitores de tela. */
export function FormAlert({ children }: { children: ReactNode }): ReactNode {
  return (
    <div role="alert" className="rounded-md border border-destructive p-3 text-sm">
      {children}
    </div>
  );
}
